/*eslint-disable*/
const STORE =
  typeof window === 'undefined' ? process.env : window.APP_ENV_SETTINGS || {};

const NODE_ENV = STORE.NODE_ENV || 'development';
const IS_DEV = STORE.NODE_ENV !== 'production';
const TYPO3_URL = (STORE.TYPO3_URL || 'http://www.test.ni.de').replace(
  /\/+$/,
  ''
);
const GRAPHQL_ENDPOINT =
  STORE.GRAPHQL_ENDPOINT || `https://www.test.ni.de/graphql`;

const IS_TEST =
  typeof (global && global.test && global.test.skip) === 'function';

const COOKIE_DOMAIN = STORE.COOKIE_DOMAIN || '.test.ni.de';

const { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_CALLBACK_URL, AUTH0_AUDIENCE } =
  STORE;

const AUTH_ROUTES = {
  LOGIN: '/auth/login/',
  SIGNUP: '/auth/signup/',
  LOGOUT: '/auth/logout/',
};

const AUTH_LOGGED_IN_PARAMETER = 'loggedIn';

export {
  IS_DEV,
  IS_TEST,
  NODE_ENV,
  TYPO3_URL,
  GRAPHQL_ENDPOINT,
  AUTH0_CLIENT_ID,
  AUTH_ROUTES,
  AUTH0_DOMAIN,
  AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL,
  AUTH_LOGGED_IN_PARAMETER,
  COOKIE_DOMAIN,
};
